<script>
import LandingLead from './components/LandingLead.vue';
import LandingNav from './components/LandingNav.vue';
import LandingArticles from './components/LandingArticles.vue';
import EditorsChoiceBanner from '../../components/EditorsChoiceBanner.vue';
import initAnalytics, { setSiteId, setPageName } from '../../utils/analytics';
import { fetchData } from '../../utils/api';

export default {
  name: 'LandingPage',
  components: {
    EditorsChoiceBanner,
    LandingLead,
    LandingNav,
    LandingArticles,
  },
  inheritAttrs: false,
  props: {
    heroImageInfo: {
      type: Object,
      default: null,
    },
    leadModel: {
      type: Object,
      default: null,
    },
    cardsModel: {
      type: Object,
      default: null,
    },
    bannerModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      content: {
        heroImageInfo: this.heroImageInfo,
        leadModel: this.leadModel,
        cardsModel: this.cardsModel,
        bannerModel: this.bannerModel,
      },
    };
  },
  computed: {
    renderPage() {
      return this.leadModel
        && this.cardsModel
        && this.heroImageInfo;
    },
    renderLead() {
      return this.leadModel
        && this.heroImageInfo.url
        && this.heroImageInfo.altText
        && this.leadModel.heading
        && this.leadModel.text;
    },
    renderArticles() {
      return this.cardsModel
      && this.cardsModel.cards;
    },
    bannerImages() {
      const imageUrls = {};

      if (this.bannerModel.heroImageInfos && this.bannerModel.heroImageInfos.length) {
        this.bannerModel.heroImageInfos.forEach((imageInfo) => {
          switch (imageInfo.key) {
            case 'image_mobile':
              imageUrls.mobile = imageInfo.heroImageInfo.url;
              break;
            case 'image_desktop':
              imageUrls.desktop = imageInfo.heroImageInfo.url;
              break;
            default:
              //
          }
        });
      }

      return imageUrls;
    },
  },
  mounted() {
    setSiteId('expert advice');
    setPageName('home');
    initAnalytics('#ea_landing-page');

    // Register for Live Preview Update Events
    window.addEventListener('OnLivePreviewUpdate', (event) => {
      const hash = event?.detail?.hash;
      if (hash) {
        fetchData(`/learn/home/preview?hash=${hash}`, this.updateData);
      }
    });
  },
  methods: {
    updateData(data) {
      this.content = data;
      this.$forceUpdate();
    },
  },
};
</script>

<template>
  <div
    v-if="renderPage"
    id="ea_landing-page"
    class="ea-landing-page"
  >
    <landing-lead
      v-if="renderLead"
      id="ea_lead"
      :hero-image="content.heroImageInfo.url"
      :hero-alt="content.heroImageInfo.altText"
      :heading="content.leadModel.heading"
      :text="content.leadModel.text"
      class="ea-landing-page__lead"
    />
    <landing-nav
      id="ea_nav"
      class="ea-landing-page__nav"
    />
    <editors-choice-banner
      :header="content.bannerModel.heading"
      :body="content.bannerModel.bodyText"
      :button-text="content.bannerModel.buttonLabel"
      :image-mobile="bannerImages.mobile"
      :image-desktop="bannerImages.desktop"
    />
    <landing-articles
      v-if="renderArticles"
      id="ea_articles"
      :cards="content.cardsModel.cards"
      class="ea-landing-page__articles"
    />
  </div>
</template>

<style lang="scss">
  @import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
  @import '../../../style/common/editor-styles.scss';

  h1, h2, h3, h4, p {
    margin-block-end: unset;
    margin-block-start: unset;
  }

  .ea-landing-page {
    & > * + * {
      margin-top: $cdr-space-two-x;
    }
    margin-bottom: $cdr-space-two-x;
    .ea-landing-page__nav {
      margin-top: $cdr-space-four-x;
    }
  }
</style>
